module.exports = __webpack_public_path__ + "static/navigator-9a4b5683bd4c2b29be8eff4a886eabc2.png";